import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["distanceIndicator", "location", "maplink"];

  connect() {
    // 1. INSTANT CHECK: Use your existing global state!
    if (window.appLocationState && window.appLocationState.lat) {
      this.updateAllDistances(
        window.appLocationState.lat,
        window.appLocationState.lng,
      );
    }

    // 2. LISTEN: Hook into your existing custom event!
    this.updateHandler = (e) => {
      this.updateAllDistances(e.detail.latitude, e.detail.longitude);
    };
    window.addEventListener("user-location-updated", this.updateHandler);
  }

  disconnect() {
    window.removeEventListener("user-location-updated", this.updateHandler);
  }

  updateAllDistances(userLat, userLng) {
    if (!userLat || !userLng) return;

    // --- LOGIC A: FOR THE INDEX PAGE (Many Cards) ---
    if (this.hasDistanceIndicatorTarget) {
      this.distanceIndicatorTargets.forEach((indicator) => {
        const dealLat = parseFloat(indicator.dataset.lat);
        const dealLng = parseFloat(indicator.dataset.lng);

        if (dealLat && dealLng) {
          const distance = this.getDistanceFromLatLonInKm(
            userLat,
            userLng,
            dealLat,
            dealLng,
          );
          const textSpan = indicator.querySelector(".distance-value");
          if (textSpan) textSpan.textContent = `${distance} km`;
        } else {
          const textSpan = indicator.querySelector(".distance-value");
          if (textSpan) textSpan.textContent = "N/A";
        }
      });
    }

    // --- LOGIC B: FOR THE SHOW PAGE (Single Deal) ---
    const dealLat = parseFloat(this.element.dataset.geolocationLatitudeValue);
    const dealLng = parseFloat(this.element.dataset.geolocationLongitudeValue);

    if (dealLat && dealLng && this.hasLocationTarget) {
      const distance = this.getDistanceFromLatLonInKm(
        userLat,
        userLng,
        dealLat,
        dealLng,
      );
      this.locationTarget.textContent = `${distance} km away`;

      // Update the Map Link dynamically based on real GPS
      if (this.hasMaplinkTarget) {
        const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${dealLat},${dealLng}&travelmode=driving`;

        // FIXED: Replaced large rounded-xl button with sleek rounded-full pill button to match map_controller.js
        this.maplinkTarget.innerHTML = `
          <a href="${mapsUrl}" target="_blank" class="w-full flex items-center justify-center gap-1 px-3 py-2 bg-gray-900 text-white font-semibold rounded-full hover:bg-gray-800 transition-all shadow-sm active:scale-95">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11" /></svg>
            <span class="text-xs">Directions</span>
          </a>
        `;
      }
    }
  }

  // Your exact math function
  getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (R * c).toFixed(1);
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180);
  }
}
